<template>
  <div>
    <el-form-item :label="field.name + '：'" label-width="110px">
      <div class="service-list">
        <draggable v-model="config[field.key]">
          <el-row class="service-item" v-for="(item,index) in config[field.key]" :key="index" type="flex" justify="space-between">
            <div class="link-name" v-text="config[field.key][index]['name']"></div>
            <el-button size="small" @click="removeArticleItem(index)" class="del-btn">删除</el-button>
          </el-row>
        </draggable>
      </div>
      <el-button size="small" @click="openDialog">添加砍价商品／服务</el-button>
    </el-form-item>
    <el-dialog title="请选择砍价活动" :visible.sync="dialog.visible" @close='closeDialog'>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="商品" name="goods"></el-tab-pane>
        <el-tab-pane label="服务" name="service"></el-tab-pane>
      </el-tabs>
      <form-group-list :url="tableList.url" @close='closeDialog' :priceField="tableList.priceField" :searchField="tableList.searchField" :params="tableList.params" :resultArrayName="tableList.resultArrayName" :multi="tableList.multi" :idList="idList" @unSelect="unSelect" @select="select"></form-group-list>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.service-list {
  margin-top: -5px;
}
.service-item {
  cursor: pointer;
  padding: 5px 5px 5px 10px;
  &:hover {
    background: #f5f7fa;
  }
}
.link-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  padding-right: 20px;
}
.del-btn {
  height: 32px;
  margin-top: 4px;
}
</style>

<script>
import Util from "@/js/util";
import _ from "lodash";
import draggable from "vuedraggable";
export default {
  name: "tms-type-bargain-list",
  props: {
    field: {
      type: [Object, Array],
      required: true
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dialog: {
        visible: false
      },
      linkNameList: {},
      currentIndex: 0,
      activeName: "goods",
      tableList: {
        url: "wdzg/b/bargain/activity/list",
        resultArrayName: "bargain_activity_list",
        priceField: 'base_price',
        searchField: 'name',
        params: {
          item_type: 1,
          life_cycle: 5
        },
        multi: true
      }
    };
  },

  computed: {
    idList() {
      let list = [];
      this.config[this.field.key].map(val => {
        list.push(val.id);
      });
      return list;
    }
  },

  components: {
    draggable
  },

  created() {},

  methods: {
    openDialog() {
      this.dialog.visible = true;
    },
    removeArticleItem(index) {
      this.config[this.field.key].splice(index, 1);
    },
    handleUpload(src, index) {
      this.$set(this.config[this.field.key][index], image_url, src);
    },
    /**
     * tab-card切换回调
     * url:               请求的URL
     * searchField:       搜索的字段名称
     * titleName:         列表的标题名称
     * resultArrayName:   返回的数据列表字段名称
     * count:             数据条数
     */
    handleClick() {
      switch (this.activeName) {
        // 砍价商品
        case "goods":
          this.tableList = {
            url: "wdzg/b/bargain/activity/list",
            resultArrayName: "bargain_activity_list",
            priceField: 'base_price',
            searchField: 'name',
            params: {
              item_type: 1,
              life_cycle: 5
            },
            multi: true
          };
          break;
        // 砍价服务
        case "service":
          this.tableList = {
            url: "wdzg/b/bargain/activity/list",
            resultArrayName: "bargain_activity_list",
            priceField: 'base_price',
            searchField: 'name',
            params: {
              item_type: 2,
              life_cycle: 5
            },
            multi: true
          };
          break;
      }
    },
    openDialog(index) {
      this.currentIndex = index;
      this.dialog.visible = true;
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    select(row) {
      let item = _.cloneDeep(row);
      delete item.rich_detail;
      item.cms_url = "/cms/page/biz/bargain.html?id=" + item.id;
      item.base_price = Util.filterPriceToFen(item.base_price);
      this.config[this.field.key].push(item);
    },
    unSelect(row, index) {
      console.log(this.config[this.field.key], index)
      this.config[this.field.key].splice(index, 1);
    }
  }
};
</script>
